import * as math from "mathjs";
import React, { useEffect, useState } from "react";
import { ICON } from "../../assets";
import { getPricesSteps } from "../../utils_price";
import useTranslations from "../Translations/useTranslations";
import UiButton from "../ui/UiButton";
import UiIcon from "../ui/UiIcon";
import UiTag from "../ui/UiTag";
import { UI_TAG_TYPE } from "../ui/UiTag/index";
import "./ArticleCard.css";

function ArticleCard({
  article,
  current_cart,
  addToLocalCart,
  groupe_tarifaire,
  selectArt,
  gen_in_cumul,
  generique,
  selectedArt,
  isPack = false,
}) {
  const articleAvailable =
    article.prices &&
    article.prices.length > 0;
  const trl = useTranslations();

  const _article = {
    ...article,
    ...article.article,
    groupe_tarifaire,
    gen_in_cumul,
    generique,
  };

  const artInCart =
    (current_cart &&
      current_cart.find((art) => art.article.CODART === _article.CODART)) ||
    {};

  const [qte, setQte] = useState(artInCart.qte_commande || 0);

  const [currentQuantity, updateQuantity] = useState(qte);

  const [remiseCalculated, setRemiseCalculated] = useState(0);
  const changeQte = (qte) => {
    if (qte < 0) return;
    setQte(qte);
  };

  const { pricesSteps, nbUnit, minIncrement, priceStep, priceStepRef } =
    getPricesSteps(article, qte);

  const [currentPrice, setCurrentPrice] = useState(0);

  useEffect(() => {
    const remise =
      _article.REMISE_FIXE > 0
        ? _article.REMISE_FIXE
        : _article.groupe_tarifaire.REMISE_FIXE > 0
          ? _article.groupe_tarifaire.REMISE_FIXE
          : artInCart && artInCart.custom_remise > 0
            ? artInCart.custom_remise
            : null;

    setRemiseCalculated(remise);
    let currentRemise = remise;
    if (groupe_tarifaire.TRANCHE5 > 0 && qte >= groupe_tarifaire.TRANCHE5) {
      currentRemise = groupe_tarifaire.REMISE5;
    } else if (
      groupe_tarifaire.TRANCHE4 > 0 &&
      qte >= groupe_tarifaire.TRANCHE4
    ) {
      currentRemise = groupe_tarifaire.REMISE4;
    } else if (
      groupe_tarifaire.TRANCHE3 > 0 &&
      qte >= groupe_tarifaire.TRANCHE3
    ) {
      currentRemise = groupe_tarifaire.REMISE3;
    } else if (
      groupe_tarifaire.TRANCHE2 > 0 &&
      qte >= groupe_tarifaire.TRANCHE2
    ) {
      currentRemise = groupe_tarifaire.REMISE2;
    } else if (
      groupe_tarifaire.TRANCHE1 > 0 &&
      qte >= groupe_tarifaire.TRANCHE1
    ) {
      currentRemise = groupe_tarifaire.REMISE1;
    } else {
      currentRemise = 0;
    }

    if (article.prices?.length > 0 && priceStep && priceStepRef) {
      const tieredRemise = Math.max(
        math.round((1 - priceStep.price / priceStepRef.price) * 100, 2),
        0,
      );
      currentRemise = Math.max(currentRemise, tieredRemise);
    }

    if (article.prices?.length > 0 && !article.pricesref) {
      // if article and no prices ref => use is in net price => no remise displayed
      currentRemise = 0;
    }

    setRemiseCalculated(currentRemise);

    if (priceStep) {
      setCurrentPrice(
        (
          (((priceStep.price * qte) / nbUnit) * (100 - currentRemise)) /
          100
        ).toFixed(2),
      );
    }
  }, [
    qte,
    priceStep,
    priceStepRef,
    _article,
    artInCart,
    groupe_tarifaire,
    nbUnit,
  ]);

  function readerProductCardInfo() {
    const minimumOrder = isPack ? _article.QTE : minIncrement;
    return (
      <React.Fragment>
        <div className="product-card-info">
          <div className="product-card-title">
            {_article.CODART} -{" "}
            {trl.data.message("ART", "CODART", _article.CODART, "LIBART")}
          </div>
          <div className="product-card-subtitle">
            <li>
              Qté{isPack ? "" : " minimum"} : {minimumOrder}{" "}
              {minimumOrder > 1 ? "unités" : "unité"}
            </li>
            {priceStep && (
              <li>
                Prix unitaire sans remise :{" "}
                <span className="unit-price">{priceStep.price} €</span>
              </li>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  function readerProductCardControls() {
    if (isPack) return null;
    function removeAction() {
      if (qte - minIncrement < 0) return;
      changeQte(qte - minIncrement);
    }
    function addAction() {
      changeQte(qte + minIncrement);
    }
    function submitConfirmation() {
      addToLocalCart(_article, qte);
      updateQuantity(qte);
    }

    return (
      <React.Fragment>
        <div className="product-card-controls">
          <div className="product-card-control-group">
            <div className="product-card-add-remove-buttons">
              <UiButton
                content={<UiIcon icon={ICON.minusIcon} alt="minus-icon" />}
                onClick={removeAction}
                disabled={qte <= 0}
                size="sm"
              />
              <div className="product-card-quantity">{qte}</div>
              <UiButton
                content={<UiIcon icon={ICON.plusIcon} alt="plus-icon" />}
                onClick={addAction}
                size="sm"
              />
            </div>
            <div className="product-card-price">
              {currentPrice && qte > 0 && (
                <React.Fragment>
                  <UiIcon
                    icon={ICON.confirmationPinkIcon}
                    alt="confirmation-pink-icon"
                    size="md"
                  />
                  <span>{currentPrice} €</span>
                </React.Fragment>
              )}
            </div>
          </div>
          <UiButton
            content={"Ajouter au panier"}
            onClick={submitConfirmation}
            disabled={currentQuantity === qte}
            style={{
              display: currentQuantity === 0 && qte === 0 ? "none" : "block",
            }}
            size="md"
          />
        </div>
      </React.Fragment>
    );
  }

  function readerProductCardDiscount() {
    if (isPack) return null;
    const hasDiscount = [
      {
        qte: groupe_tarifaire.TRANCHE1,
        remise: groupe_tarifaire.REMISE1,
      },
      {
        qte: groupe_tarifaire.TRANCHE2,
        remise: groupe_tarifaire.REMISE2,
      },
      {
        qte: groupe_tarifaire.TRANCHE3,
        remise: groupe_tarifaire.REMISE3,
      },
      {
        qte: groupe_tarifaire.TRANCHE4,
        remise: groupe_tarifaire.REMISE4,
      },
      {
        qte: groupe_tarifaire.TRANCHE5,
        remise: groupe_tarifaire.REMISE5,
      },
    ];
    const discountList = hasDiscount.filter(
      (t) => t.qte && t.qte > 0 && t.remise && t.remise > 0,
    );
    if (discountList.length === 0) return null;

    const calculatePriceByQte = (qte, remise) => {
      if (qte <= 0 || !priceStep) return 0;
      return ((priceStep.price / nbUnit) * (1 - remise / 100)).toFixed(2);
    };

    return (
      <React.Fragment>
        <div className="product-card-discount">
          <UiTag
            uiTagType={UI_TAG_TYPE.informative}
            content="Vos remises"
            rounded={true}
          />
          <div className="product-card-discount-list">
            {discountList.map((t, index) => (
              <React.Fragment key={index}>
                <div className="product-card-discount-item">
                  <UiIcon icon={ICON.pinkTagIcon} size="md" />
                  <span>{t.qte} unités :</span>
                  <span className="product-card-discount-price">
                    {calculatePriceByQte(t.qte, t.remise)} €
                  </span>
                  <span>/unité</span>
                  <UiTag
                    uiTagType={UI_TAG_TYPE.highlightColor}
                    content={<span className="discount-tag">-{t.remise}%</span>}
                    size="md"
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  }

  function readerProductCard() {
    if (article.prices && (article.prices.length === 0 || !articleAvailable)) {
      if (!_article.CODART) return null;
      return (
        <React.Fragment>
          <div
            className="product-card-container"
            onMouseEnter={() => selectArt(_article)}
            style={{
              backgroundColor:
                selectedArt.CODART === _article.CODART
                  ? "#F9F9F9"
                  : "transparent",
            }}
          >
            <div className="product-card-info">
              <div className="product-card-title">
                {_article.CODART} -{" "}
                {trl.data.message("ART", "CODART", _article.CODART, "LIBART")}
              </div>
              <div className="product-card-subtitle">
                <span>Prix sur demande - Rajouter en commentaire
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div
          className="product-card-container"
          onMouseEnter={() => selectArt(_article)}
          style={{
            backgroundColor:
              selectedArt.CODART === _article.CODART
                ? "#F9F9F9"
                : "transparent",
          }}
        >
          {readerProductCardInfo()}
          {readerProductCardDiscount()}
          {readerProductCardControls()}
        </div>
      </React.Fragment>
    );
  }

  return <React.Fragment>{readerProductCard()}</React.Fragment>;
}

export default ArticleCard;
